import { useEscapeKey } from '@/hooks/useEscapeKey';
import { useEffect } from 'react';

type StatusModalProps = {
  kind: 'success' | 'error';
  message: string;
  onClose: () => void;
  /** Za jak dlouho sám zmizí (ms). */
  duration?: number;
};

/**
 * Vycentrované modal okno s velkou fajfkou / křížkem a zprávou. Samo po pár
 * vteřinách zmizí (nebo kliknutím na pozadí). Náhrada za toast vpravo dole.
 */
export function StatusModal({ kind, message, onClose, duration = 2500 }: StatusModalProps) {
  useEffect(() => {
    const t = setTimeout(onClose, duration);
    return () => clearTimeout(t);
  }, [onClose, duration]);

  useEscapeKey(onClose);

  const isOk = kind === 'success';

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4">
      <button
        type="button"
        aria-label="Zavřít"
        onClick={onClose}
        className="absolute inset-0 bg-black/50 backdrop-blur-sm cursor-default"
      />
      <div className="relative w-full max-w-sm bg-surface rounded-2xl shadow-modal px-8 py-8 flex flex-col items-center gap-4 text-center reveal">
        <div
          className={`flex items-center justify-center w-20 h-20 rounded-full ${
            isOk ? 'bg-success-light text-success' : 'bg-danger-light text-danger'
          }`}
        >
          <svg
            width="44"
            height="44"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2.5"
            strokeLinecap="round"
            strokeLinejoin="round"
            aria-hidden="true"
          >
            {isOk ? <polyline points="20 6 9 17 4 12" /> : <path d="M18 6L6 18M6 6l12 12" />}
          </svg>
        </div>
        <p className="text-base font-semibold text-text">{message}</p>
      </div>
    </div>
  );
}
